import React from 'react';
import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Input = styled.input`
  appearance: none;
  position: relative;
  background-color: ${color('white')};
  border: 1px solid ${color('gray70')};
  border-radius: 50%;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  transition-property: background-color, border-color;
  transition-duration: ${(props) => props.theme.transition.duration};
  transition-timing-function: ${(props) => props.theme.transition.timing};

  &:hover {
    background-color: ${color('gray20')};
  }

  &:focus {
    background-color: ${color('gray20')};
  }

  &:before {
    content: '';
    display: block;
    background-color: ${color('white')};
    width: 10px;
    height: 10px;
    border-radius: 50%;
    opacity: 0;
    transition-property: opacity;
    transition-duration: ${(props) => props.theme.transition.duration};
    transition-timing-function: ${(props) => props.theme.transition.timing};
  }

  &:checked {
    background-color: ${color('navy100')};
    border-color: ${color('navy100')};

    &:before {
      content: '';
      display: block;
      background-color: ${color('white')};
      width: 10px;
      height: 10px;
      border-radius: 50%;
      opacity: 1;
    }
  }

  &:disabled {
    background-color: ${color('navy100')};
    opacity: 0.2;
    cursor: not-allowed;
  }
`;

const Text = styled.span`
  margin-left: ${gutter(1.5)};
`;

interface RadioProps extends React.ComponentPropsWithoutRef<'input'> {
  label?: string;
}

export const Radio = ({ label, ...rest }: RadioProps) => {
  return (
    <Label>
      <Input type="radio" {...rest} />
      {label && <Text>{label}</Text>}
    </Label>
  );
};
